export default __webpack_public_path__ + "static/media/M51.17e9fcee.svg";